import {
	Flex,
	HStack,
	PinInput,
	PinInputField,
	Spinner,
	Stack,
	Text,
	VStack,
	Heading,
	Box,
	chakra,
	useDisclosure,
} from '@chakra-ui/react'
import React, { useState } from 'react'
import 'react-phone-input-2/lib/style.css'
import {
	GA_CATEGORY_LOGIN,
	sectionDetailedTrack,
} from '../../../containers/repository/repo.utils'
import { useAuthContext } from '../../../context/auth.context'
import { useSendCognitoOtp, useValidateOtp } from '../../../hooks/login.hooks'
import { loginConst } from '../../../utils/action.constant'
import { dataLayerTagManager } from './../../../containers/repository/repo.utils'
import { AUTH_SESSION_CHECK, AUTH_SESSION_DATA } from '../../../utils/constant'
import { EMAIL_FORM_VIEW } from './../email-login/email.config'
import { FORM_VIEW } from './../otp-login/otp.config'
import TermsAndConditions from './../../termsAndConditions/index'
import ButtonCTA from './../../globalComponents/button/index'
import AWS from 'aws-sdk'

export default function OTPNumberInput({
	isEmailView = false,
	user,
	onValidationSuccess,
	phoneDetail,
	setView,
}) {
	const { dispatch } = useAuthContext()
	const { mutate, isLoading, isError } = useValidateOtp()

	const [otp, setOtp] = useState('')
	const [isResend, setIsResend] = useState(false)

	const { isOpen, onOpen, onClose } = useDisclosure()

	const {
		mutate: resendMutate,
		isLoading: isSending,
		isError: sendError,
	} = useSendCognitoOtp()

	const resendOtp = () => {
		setOtp('')
		let payload = {
			email: user.username,
		}
		if (!isEmailView && !!phoneDetail) {
			payload = {
				countryCode: phoneDetail.country, // user.username.slice(0, 3),
				mobile: phoneDetail.phone, /// user.username.slice(3),
			}
		}
		resendMutate(payload, {
			onSuccess: data => {
				console.log(['OTP SENT', data])
				setIsResend(data)
			},
		})
	}

	const onSetOTPAwsConfig = ({ idToken }) => {
		// Set the region where your identity pool exists (us-east-1, eu-west-1)
		AWS.config.region = process.env.REACT_APP_AWS_REGION

		// Configure the credentials provider to use your identity pool
		AWS.config.credentials = new AWS.CognitoIdentityCredentials({
			IdentityPoolId: process.env.REACT_APP_OTP_IDENTITY_POOL_ID,
			Logins: {
				[`cognito-idp.ap-south-1.amazonaws.com/${process.env.REACT_APP_OTP_USER_POOL_ID}`]:
					idToken.jwtToken,
			},
		})
	}

	const validateOtp = otp => {
		mutate(
			{
				user: isResend || user,
				otp,
			},
			{
				onSuccess: data => {
					sessionStorage.setItem(AUTH_SESSION_DATA, JSON.stringify(data))
					sessionStorage.setItem(AUTH_SESSION_CHECK, true)
					dispatch({
						type: loginConst.LOGIN,
						payload: {
							// username,
							// token,
							...data,
							phoneDetail,
						},
					})
					onSetOTPAwsConfig(data)
					onValidationSuccess()
				},
			}
		)
	}

	return (
		<>
			<TermsAndConditions isOpen={isOpen} onClose={onClose} />

			<VStack w='350px' spacing={4} mt={4} mb={4} justifyContent='center'>
				<Flex
					justifyContent='center'
					alignItems='center'
					gap={1}
					direction='column'
				>
					<Heading fontWeight='900' fontSize='1.875rem' lineHeight='2.6rem'>
						OTP Verification
					</Heading>
					<Text fontWeight='400' fontSize='md' textAlign='center'>
						We have sent a verification code to
					</Text>
					<Text
						color='rgba(0, 0, 0, 0.85)'
						fontWeight='500'
						fontSize='0.875rem'
						display='inline-block'
						mb={4}
					>
						{`${user?.username} `}

						<ButtonCTA
							variant='linkAsButton'
							fontSize='0.875rem'
							fontWeight='900'
							lineHeight='1.375rem'
							verticalAlign='baseline'
							onClick={() => {
								if (isEmailView) setView(EMAIL_FORM_VIEW.EMAIL_VIEW)
								else setView(FORM_VIEW.PHONE_VIEW)
							}}
						>
							Change
						</ButtonCTA>
					</Text>{' '}
					<HStack w='100%' justifyContent='center'>
						<PinInput
							size='md'
							type='number'
							variant='flushed'
							value={otp}
							onChange={value => {
								setOtp(value)
							}}
							onComplete={validateOtp}
							isDisabled={!!isLoading}
						>
							<PinInputField />
							<PinInputField />
							<PinInputField />
							<PinInputField />
							<PinInputField />
							<PinInputField />
						</PinInput>
					</HStack>
					<ButtonCTA
						type='submit'
						bg='brand.800'
						color='#828282'
						size='md'
						minW='320px'
						borderRadius='22px'
						background='gray.600'
						border='1px solid #D9D9D9'
						_hover={{
							color: 'white',
							background:
								'linear-gradient(268.34deg, #139988 10.16%, #008A4B 102.89%)',
						}}
						fontWeight='900'
						fontSize='1rem'
						lineHeight='1.375rem'
						onClick={() => {
							sectionDetailedTrack({
								category: GA_CATEGORY_LOGIN,
								action: 'Resend OTP',
							})
							dataLayerTagManager('button_click', {
								viewName: 'Login',
								buttonName: 'Re-Send OTP',
							})
							resendOtp()
						}}
						isLoading={!!isSending}
					>
						RE-SEND OTP
					</ButtonCTA>
				</Flex>
				{isError && (
					<Text color='red.300' fontWeight='400' fontSize='sm'>
						Invalid otp please provide the correct one.
					</Text>
				)}
				{!!isLoading ? (
					<Stack
						my={3}
						justifyContent='center'
						direction='column'
						alignItems='center'
					>
						<Spinner size='lg' color='brand.900' />
						<Text color='brand.900'>Please, wait...</Text>
					</Stack>
				) : null}
				<Box fontWeight='500' color='gray.400'>
					<Text>By clicking Verify & Proceed, I accept the</Text>
					<Text>
						<ButtonCTA
							variant='linkAsButton'
							fontSize='0.875rem'
							fontWeight='500'
							lineHeight='1.375rem'
							verticalAlign='baseline'
							onClick={onOpen}
						>
							Terms & Conditions
						</ButtonCTA>{' '}
						<chakra.span lineHeight='1.375rem'>and</chakra.span>{' '}
						<ButtonCTA
							variant='linkAsButton'
							fontSize='0.875rem'
							fontWeight='500'
							lineHeight='1.375rem'
							verticalAlign='baseline'
							onClick={onOpen}
						>
							Privacy Policy
						</ButtonCTA>
					</Text>
				</Box>
			</VStack>
		</>
	)
}
